import {Link} from "react-router-dom";

import { useUiStore } from '@/stores/ui-store';
import type { PostAccidentResponse } from '@/types/api/accident';

const ConfirmationSinistre = () => {
    /* Réponse de la déclaration (`data` de l'enveloppe) : lien de prise de rendez-vous, s'il y en a un. */
    const accidentResonse = useUiStore((state) => state.postAccidentResponse) as PostAccidentResponse | undefined

    return (
        <div className={'my-4'}>
            <div className={'mt-12'}>
                <h1 className={'font-bold'}>
                    <Link to={'/mes-sinistres'} aria-label="Retour aux sinistres">
                        <i className="bi bi-arrow-left-circle mr-2" aria-hidden="true" />
                    </Link>{' '}
                    Mes sinistres
                </h1>
            </div>
            <div className="p-4 rounded-md mb-4 bg-success/15 border border-success text-foreground" role="alert">
                {
                    'Votre déclaration de sinistre a bien été enregistrée ! Un(e) gestionnaire reprendra contact avec vous sous 48h.'
                }
            </div>

            <div className={'bloc-white'}>
                <div>
                    <h2 className={'font-bold text-[oklch(from_var(--color-primary)_calc(l*0.95)_c_h)] inline-block mb-6'}>
                        Vous souhaitez être recontacté(e) à une heure précise, prenez rendez-vous&nbsp;!
                    </h2>
                </div>

                <a
                    href={accidentResonse?.url ?? undefined}
                    className={'inline-flex items-center justify-center gap-2 px-5 py-2.5 text-[0.875rem]/5 font-medium rounded-md transition-all ease-[ease] cursor-pointer no-underline disabled:opacity-50 disabled:pointer-events-none bg-primary text-primary-foreground border-none hover:bg-primary-hover'}
                    target={'_blank'}
                    rel="noopener noreferrer"
                >
                    Prendre rendez-vous
                </a>
            </div>
        </div>
    );
}

export default ConfirmationSinistre;
